// import * as faceapi from "@vladmandic/face-api";

let modelsLoaded = false;

export const loadModels = async () => {
  if (modelsLoaded) return;
  const MODEL_URL = "https://cdn.jsdelivr.net/npm/@vladmandic/face-api/model/";
  await Promise.all([window.faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL)]);
  modelsLoaded = true;
};

export const detectFace = async (imageElement) => {
  await loadModels();

  // Guard clause: Wait for the image element to fully load into DOM memory
  if (imageElement && !imageElement.complete) {
    await new Promise((resolve) => {
      imageElement.onload = resolve;
      imageElement.onerror = resolve; // Prevent permanent hanging on broken links
    });
  }

  // Configure relaxed matching rules
  const options = new window.faceapi.TinyFaceDetectorOptions({
    inputSize: 416, // Increased from 160/224. Must be a multiple of 32.
    scoreThreshold: 0.1, // Dropped to 10% to catch lower confidence profiles
  });

  const detection = await window.faceapi.detectSingleFace(
    imageElement,
    new window.faceapi.TinyFaceDetectorOptions()
  );
  return detection;
};

/**
 * Calculates the crop parameters based on dynamic settings.
 * NO CLAMPING: We allow negative coordinates to facilitate consistent head size via padding.
 */
export const calculateAutoCrop = (
  detection,
  imageWidth,
  imageHeight,
  zoom,
  aspectRatio,
  horizontalOffset = 0,
  verticalOffset = 0
) => {
  const { box } = detection;

  // 1. Determine base frame height based on zoom (formerly faceScale) setting
  // This ensures the face is ALWAYS exactly zoom % of the frame height
  const desiredFrameHeight = box.height / zoom;
  const desiredFrameWidth = desiredFrameHeight * aspectRatio;

  // 2. Eye level estimation (approx 40% down face box)
  const eyeLevelY = box.y + box.height * 0.4;

  // 3. Place eyes at fixed rule-of-thirds eyeLine (30%) + manual vertical nudge
  const eyeLine = 0.3;
  const verticalShiftAmount = verticalOffset * desiredFrameHeight;
  const cropTop = eyeLevelY - desiredFrameHeight * eyeLine + verticalShiftAmount;

  // 4. Horizontal Centering + User Offset
  const targetCenterX = box.x + box.width / 2;
  const horizontalShiftAmount = horizontalOffset * desiredFrameWidth;
  const cropLeft = targetCenterX - desiredFrameWidth / 2 + horizontalShiftAmount;

  // 5. Final Coordinates (Unclamped)
  return {
    x: cropLeft,
    y: cropTop,
    width: desiredFrameWidth,
    height: desiredFrameHeight,
  };
};
